import { Location } from 'history';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { getRouterState } from '../../../global/selectors';
import { LocationState } from '../../../global/types';
import { defaultSortOrder } from '../constants';
import { CustomersSortOrder } from '../types';

type CustomersQueryParams = {
  location: Location<LocationState>;
  locationState: LocationState;
  search: string;
  sortOrder: CustomersSortOrder;
  start: number;
};

const parseOrdersSortOrder = (sort: string): CustomersSortOrder => {
  const sortOrders = Object.values(CustomersSortOrder);
  return sortOrders.includes(sort as CustomersSortOrder)
    ? (sort as CustomersSortOrder)
    : defaultSortOrder;
};

const useCustomersQueryParams = (): CustomersQueryParams => {
  const { location } = useSelector(getRouterState);
  const parsed = queryString.parse(location.search);
  const start: number = parsed.start ? parseInt(parsed.start.toString(), 10) : 0;
  const search: string = parsed.search ? parsed.search.toString() : '';
  const sortOrder = parseOrdersSortOrder(parsed.sort ? parsed.sort.toString() : '');
  const { state } = location;

  return {
    location,
    locationState: state,
    search,
    sortOrder,
    start,
  };
};

export default useCustomersQueryParams;
